"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paddings = void 0;
exports.paddings = {
    xs: "p-2",
    sm: "p-4",
    md: "p-6",
    lg: "p-8",
    xl: "p-10",
    "2xl": "p-12",
    "3xl": "p-14",
    "4xl": "p-16",
    "5xl": "p-18",
    "6xl": "p-20",
    "7xl": "p-22",
    "8xl": "p-24",
    "9xl": "p-26",
    0: "p-0",
    0.5: "p-0.5",
    1: "p-1",
    1.5: "p-1.5",
    2: "p-2",
    2.5: "p-2.5",
    3: "p-3",
    3.5: "p-3",
    4: "p-4",
    4.5: "p-4.5",
    5: "p-5",
    6: "p-6",
    7: "p-7",
    8: "p-8",
    9: "p-9",
    10: "p-10",
    11: "p-11",
    12: "p-12",
    14: "p-14",
    16: "p-16",
    20: "p-20",
    24: "p-24",
    28: "p-28",
    32: "p-32",
    36: "p-36",
    40: "p-40",
    44: "p-44",
    48: "p-48",
    52: "p-52",
    56: "p-56",
    60: "p-60",
    64: "p-64",
    72: "p-72",
    80: "p-80",
    96: "p-96",
};
//# sourceMappingURL=data:application/json;base64,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